import * as React from 'react';
import clsx from 'clsx';

function BellIcon({className, color = '#585550', ...props}) {
  return (
    <svg
      className={clsx('w-6 h-6', className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 3a6 6 0 00-6 6v2.586c0 .557-.221 1.09-.615 1.485L4.28 14.176A1.6 1.6 0 005.412 17h13.176a1.6 1.6 0 001.131-2.828l-1.104-1.101a2.1 2.1 0 01-.615-1.485V9a6 6 0 00-6-6zM9.5 20a2.5 2.5 0 005 0"
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default BellIcon;
